import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

import { login } from "../../services/auth.api";
import { AUTH_STATUS } from "../../utils/authUtils";
import useAuth from "../../context/AuthContext";

import "./Login.css";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { status } = useAuth();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    if (urlParams.get("passwordReset") === "true") {
      toast.success("Password changed successfully. Please log in with your new password.");
      navigate("/", { replace: true });
    }
  }, [location.search, navigate]);

  useEffect(() => {
    const { LOADING, UNAUTHENTICATED, AUTHENTICATED } = AUTH_STATUS;

    if (status !== LOADING && status === UNAUTHENTICATED) {
      login();
    } else if (status === AUTHENTICATED) {
      navigate("/home");
    }
  }, [navigate, status]);

  return (
    <div>
      <div className="center">
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default Login;
